// assets/tc-fba-calc.js — UI for <tc-fba-calculator>. Requires tc-fba-calc-core.js loaded first.
(function () {
  'use strict';
  var PRESETS = [
    { key: 'plush', label: 'Plush / small toy', l: 9, w: 6, h: 3, weightLb: 0.625 },
    { key: 'boardgame', label: 'Board game / puzzle', l: 10.5, w: 10.5, h: 2, weightLb: 1.5 },
    { key: 'building', label: 'Building set', l: 15, w: 10, h: 4, weightLb: 3 },
    { key: 'largetoy', label: 'Large toy (play kitchen)', l: 24, w: 16, h: 12, weightLb: 12 },
    { key: 'rideon', label: 'Ride-on / scooter', l: 28, w: 10, h: 10, weightLb: 9 },
  ];
  var fmt = function (n) {
    return (n < 0 ? '−$' : '$') + Math.abs(n).toFixed(2);
  };
  // Whole-dollar figures (annual totals). Signed like fmt(), so a negative row reads
  // "−$1,355" rather than silently losing its sign to Math.abs.
  var fmtBig = function (n) {
    return (n < 0 ? '−$' : '$') + Math.round(Math.abs(n)).toLocaleString('en-US');
  };
  var RETURN_ROW_LABELS = {
    refundAdmin: 'Refund admin fee — every return',
    returnProcessing: 'Return processing fee — every return',
    productCostLost: 'Product cost lost — unsellable units',
    liquidationRecovery: 'Recovered via FBA Liquidations',
  };

  class TcFbaCalculator extends HTMLElement {
    connectedCallback() {
      if (!window.TcFbaCore) return;
      this.state = {
        preset: 'boardgame', l: 10.5, w: 10.5, h: 2, weightLb: 1.5,
        price: 69.99, unitCost: 25, inboundPerUnit: 0,
        unitsPerMonth: 500, monthsInStorage: 2, includesHoliday: false,
        returnRatePct: 15, unsellablePct: 50, resalePct: 40,
      };
      this.usedEventSent = false;
      this.renderShell();
      this.recalc();
    }

    renderShell() {
      var presetOpts = PRESETS.map(function (p) {
        return '<option value="' + p.key + '">' + p.label + '</option>';
      }).join('');
      this.innerHTML =
        '<div class="tc-fba-calc-root">' +
        '  <form class="tc-fba-form" novalidate>' +
        '    <p class="tc-fba-group">Your product</p>' +
        '    <div class="tc-fba-field tc-fba-field--wide">' +
        '      <label for="tcf-preset">Toy type</label>' +
        '      <select id="tcf-preset" name="preset">' + presetOpts + '</select>' +
        '      <p class="tc-fba-assumed" data-assumed>Assumes 10.5×10.5×2 in, 1.5 lb — <button type="button" class="tc-fba-link" data-toggle-adv>edit</button></p>' +
        '    </div>' +
        '    <div class="tc-fba-adv" data-adv hidden>' +
        '      <div class="tc-fba-field"><label for="tcf-l">Length (in)</label><input id="tcf-l" name="l" type="number" step="0.25" min="0.1"></div>' +
        '      <div class="tc-fba-field"><label for="tcf-w">Width (in)</label><input id="tcf-w" name="w" type="number" step="0.25" min="0.1"></div>' +
        '      <div class="tc-fba-field"><label for="tcf-h">Height (in)</label><input id="tcf-h" name="h" type="number" step="0.25" min="0.1"></div>' +
        '      <div class="tc-fba-field"><label for="tcf-wt">Weight (lb)</label><input id="tcf-wt" name="weightLb" type="number" step="0.05" min="0.05"></div>' +
        '      <div class="tc-fba-field"><label for="tcf-inb">Inbound shipping $/unit</label><input id="tcf-inb" name="inboundPerUnit" type="number" step="0.1" min="0"></div>' +
        '      <div class="tc-fba-field"><label for="tcf-uns">Returns unsellable as new (%)</label><input id="tcf-uns" name="unsellablePct" type="number" step="5" min="0" max="100"></div>' +
        '    </div>' +
        '    <div class="tc-fba-field"><label for="tcf-price">Sale price ($)</label><input id="tcf-price" name="price" type="number" step="0.01" min="0"></div>' +
        '    <div class="tc-fba-field"><label for="tcf-cost">Your unit cost ($)</label><input id="tcf-cost" name="unitCost" type="number" step="0.01" min="0"></div>' +
        '    <p class="tc-fba-group tc-fba-group--gap">Sales &amp; returns</p>' +
        '    <div class="tc-fba-field"><label for="tcf-units">Units sold / month</label><input id="tcf-units" name="unitsPerMonth" type="number" step="1" min="1"></div>' +
        '    <div class="tc-fba-field"><label for="tcf-months">Avg months in storage</label><input id="tcf-months" name="monthsInStorage" type="number" step="1" min="1" max="12"></div>' +
        '    <div class="tc-fba-field tc-fba-field--check"><label><input name="includesHoliday" type="checkbox"> Includes Oct–Dec (holiday rates)</label></div>' +
        '    <div class="tc-fba-field"><label for="tcf-rr">Expected return rate (%)</label><input id="tcf-rr" name="returnRatePct" type="number" step="0.5" min="0" max="100">' +
        '      <p class="tc-fba-hint">Amazon’s fee threshold for Toys &amp; Games is 4.7%</p></div>' +
        '  </form>' +
        '  <div class="tc-fba-results" aria-live="polite">' +
        '    <div class="tc-fba-panel" data-panel-unit></div>' +
        '    <div class="tc-fba-panel" data-panel-returns></div>' +
        '  </div>' +
        '</div>';
      this.syncForm();
      var self = this;
      this.querySelector('form').addEventListener('input', function (e) { self.onInput(e); });
      this.querySelector('[data-toggle-adv]').addEventListener('click', function () {
        var adv = self.querySelector('[data-adv]');
        adv.hidden = !adv.hidden;
      });
    }

    syncForm() {
      var s = this.state, form = this.querySelector('form');
      ['l', 'w', 'h', 'weightLb', 'price', 'unitCost', 'inboundPerUnit', 'unitsPerMonth',
        'monthsInStorage', 'returnRatePct', 'unsellablePct'].forEach(function (k) {
        if (form.elements[k]) form.elements[k].value = s[k];
      });
      form.elements.preset.value = s.preset;
      form.elements.includesHoliday.checked = s.includesHoliday;
    }

    onInput(e) {
      var s = this.state, t = e.target;
      if (t.name === 'preset') {
        var p = PRESETS.find(function (x) { return x.key === t.value; });
        s.preset = p.key; s.l = p.l; s.w = p.w; s.h = p.h; s.weightLb = p.weightLb;
        this.syncForm();
      } else if (t.name === 'includesHoliday') {
        s.includesHoliday = t.checked;
      } else if (t.name) {
        s[t.name] = parseFloat(t.value) || 0;
      }
      if (!this.usedEventSent) {
        this.usedEventSent = true;
        if (window.dataLayer) window.dataLayer.push({ event: 'fba_calc_used' });
      }
      this.recalc();
    }

    recalc() {
      var s = this.state;
      var assumed = this.querySelector('[data-assumed]');
      var r = window.TcFbaCore.compute(s);
      assumed.firstChild.textContent = 'Assumes ' + s.l + '×' + s.w + '×' + s.h + ' in, ' +
        (s.weightLb < 1 ? Math.round(s.weightLb * 16) + ' oz' : s.weightLb + ' lb') + ' — ';
      this.renderUnitPanel(r);
      this.renderReturnsPanel(r);
    }

    renderUnitPanel(r) {
      var s = this.state;
      var TIER_LABELS = { smallStandard: 'SMALL STANDARD', largeStandard: 'LARGE STANDARD', largeBulky: 'LARGE BULKY', extraLarge: 'EXTRA-LARGE' };
      var rows = [
        ['Referral fee (15%)', r.referral],
        ['Fulfillment fee', r.fulfillment],
        ['Fuel surcharge (3.5%)', r.fuelSurcharge],
        ['Storage (' + s.monthsInStorage + ' mo)', r.storagePerUnit],
      ];
      var stack = rows.map(function (row, i) {
        var pct = Math.max(1, (row[1] / s.price) * 100);
        return '<span class="tc-fba-stack-seg tc-fba-seg-' + (i + 1) + '" style="width:' + pct.toFixed(1) + '%" title="' + row[0] + '"></span>';
      }).join('');
      var legend = rows.map(function (row, i) {
        return '<li><span class="tc-fba-dot tc-fba-seg-' + (i + 1) + '"></span>' + row[0] + '</li>';
      }).join('');
      var feesPct = s.price > 0 ? (r.totalFees / s.price) * 100 : 0;
      var marginBad = r.netProceeds < 0;
      this.querySelector('[data-panel-unit]').innerHTML =
        '<p class="tc-fba-eyebrow">Amazon’s cut</p>' +
        '<h3>Per-unit economics</h3>' +
        '<p class="tc-fba-keyline">Amazon takes <strong>' + feesPct.toFixed(0) + '%</strong> of every ' + fmt(s.price) + ' sale.</p>' +
        '<div class="tc-fba-stack" aria-hidden="true">' + stack + '</div>' +
        '<ul class="tc-fba-legend" aria-hidden="true">' + legend + '</ul>' +
        '<div class="tc-fba-receipt">' +
        '  <div class="tc-fba-receipt-head"><span>US · Toys &amp; Games</span><span>' + (TIER_LABELS[r.tier] || '') + '</span></div>' +
        (r.billedOnDimWeight
          ? '  <div class="tc-fba-receipt-note">Billed at ' + r.shippingWeightLb.toFixed(1) + ' lb dimensional weight — Amazon charges on box size (L×W×H ÷ 139) when that exceeds the scale weight.</div>'
          : '') +
        '  <table class="tc-fba-table"><tbody>' +
        '<tr class="tc-fba-sale"><td>Sale price</td><td>' + fmt(s.price) + '</td></tr>' +
        rows.map(function (row) { return '<tr class="tc-fba-sub"><td>' + row[0] + '</td><td>' + fmt(-row[1]) + '</td></tr>'; }).join('') +
        '<tr class="tc-fba-total"><td>Total Amazon fees</td><td>' + fmt(-r.totalFees) + '</td></tr>' +
        '<tr class="tc-fba-cost"><td>Your unit cost</td><td>' + fmt(-s.unitCost) + '</td></tr>' +
        (s.inboundPerUnit > 0
          ? '<tr class="tc-fba-cost"><td>Inbound shipping</td><td>' + fmt(-s.inboundPerUnit) + '</td></tr>'
          : '') +
        '</tbody></table>' +
        '</div>' +
        '<div class="tc-fba-keep' + (marginBad ? ' tc-fba-keep--bad' : '') + '">' +
        '  <span class="tc-fba-keep-label">You keep</span>' +
        '  <span class="tc-fba-keep-num">' + fmt(r.netProceeds) + '/unit</span>' +
        '  <span class="tc-fba-keep-chip">' + r.marginPct.toFixed(1) + '% margin</span>' +
        '</div>' +
        (marginBad ? '<p class="tc-fba-note">Fees and unit cost exceed the sale price at these inputs.</p>' : '');
    }

    // Transparent annual-math breakdown. Rows are rendered from compute()'s costBreakdown,
    // rounded to displayed whole dollars ONCE via roundAndSum — the printed total is the sum
    // of the printed rows, so the table always adds up to the headline beneath it.
    renderMathDetails(ret) {
      var s = this.state;
      var agg = window.TcFbaCore.roundAndSum(ret.costBreakdown.map(function (c) { return c.amount; }), 0);
      var py = ret.perYear, un = ret.unsellablePerYear;
      var rows = ret.costBreakdown.map(function (c, i) {
        var exempt = c.key === 'returnProcessing' && c.perUnit === 0;
        return '<tr><td>' + (exempt ? 'Return processing fee' : RETURN_ROW_LABELS[c.key]) + '</td><td>' +
          (exempt ? 'exempt at your inputs' : fmt(Math.abs(c.perUnit)) + ' × ' + c.count) + '</td><td>' +
          fmtBig(agg.parts[i]) + '</td></tr>';
      }).join('') +
        '<tr class="tc-fba-total"><td>What returns cost you</td><td></td><td>≈ ' + fmtBig(agg.total) + '/yr</td></tr>';
      var delta = '';
      if (ret.annualRecoverableDelta > 0) {
        // Same treatment for the prose: print the two rounded figures and their exact difference.
        var rec = window.TcFbaCore.roundAndSum([ret.recoverable.resaleTotal, -ret.recoverable.liquidationTotal], 0);
        delta = '<p>Removing &amp; reselling those ' + un + ' units at your assumed ' + s.resalePct + '% would return ' +
          fmt(ret.recoverable.resalePerUnit) + ' × ' + un + ' ≈ ' + fmtBig(rec.parts[0]) +
          ' instead of liquidation’s ' + fmtBig(-rec.parts[1]) +
          ' — <strong>up to ' + fmtBig(rec.total) + '/year back</strong>.</p>';
      }
      return '<details class="tc-fba-math" data-math>' +
        '<summary>See the math behind these numbers</summary>' +
        '<div class="tc-fba-math-body">' +
        '<p>≈ <strong>' + py + ' returns/year</strong> = ' + s.unitsPerMonth + ' units/mo × 12 × ' + s.returnRatePct + '% return rate. ' +
        'Of those, ' + s.unsellablePct + '% (' + un + ' units) can’t be restocked as new. The total below assumes you liquidate them — the best option Amazon itself offers for toys:</p>' +
        '<table class="tc-fba-table"><tbody>' + rows + '</tbody></table>' +
        delta +
        '<p class="tc-fba-note">The refund and processing fees above are charged by Amazon the moment a customer sends an item back, whichever path it takes afterwards. Resale recovers your product’s value — no path recovers those fees.</p>' +
        '</div></details>';
    }

    renderReturnsPanel(r) {
      var s = this.state, ret = r.returns;
      var badge = ret.feeExempt
        ? '<span class="tc-fba-badge tc-fba-badge--ok">Below Amazon’s return-fee threshold</span>'
        : '<span class="tc-fba-badge">Return processing fee applies: ' + fmt(ret.returnProcessingPerReturn) + '/return</span>';
      var ctaUrl = this.dataset.ctaUrl || 'https://brands.toycycle.co';
      var ctaLabel = this.dataset.ctaLabel || 'Talk to Toycycle about your returns';
      var self = this;
      var nets = [ret.disposalNet, ret.liquidationNetMid, ret.resaleNet];
      var best = nets.indexOf(Math.max.apply(null, nets));
      var tag = '<span class="tc-fba-path-tag">Highest recovery</span>';
      this.querySelector('[data-panel-returns]').innerHTML =
        '<p class="tc-fba-eyebrow">What other calculators skip</p>' +
        '<h3>What your returns cost</h3>' +
        '<p class="tc-fba-note">≈ ' + ret.perYear + ' returns/year at your volume.</p>' +
        '<p class="tc-fba-badge-row">' + badge + '</p>' +
        '<p class="tc-fba-note">Restocked returns cost only the refund admin fee (' + fmt(ret.refundAdminPerReturn) + '). ' +
        'But <strong>FBA Grade &amp; Resell is not available for Toys or Baby</strong> — Amazon allows New (Toys: or Collectible) listings only. ' +
        'For the ' + s.unsellablePct + '% that can’t be restocked as new, your options per unit:</p>' +
        '<div class="tc-fba-paths">' +
        '  <div class="tc-fba-path' + (best === 0 ? ' tc-fba-path--best' : '') + '">' + (best === 0 ? tag : '') + '<h4>Dispose</h4><p class="tc-fba-path-num">' + fmt(ret.disposalNet) + '<span class="tc-fba-perunit">/unit</span></p><p>product written off + disposal fee</p></div>' +
        '  <div class="tc-fba-path' + (best === 1 ? ' tc-fba-path--best' : '') + '">' + (best === 1 ? tag : '') + '<h4>Liquidate</h4><p class="tc-fba-path-num">' + fmt(ret.liquidationNetLow) + ' to ' + fmt(ret.liquidationNetHigh) + '<span class="tc-fba-perunit">/unit</span></p><p>Amazon estimates 5–10% gross recovery, minus fees</p></div>' +
        '  <div class="tc-fba-path' + (best === 2 ? ' tc-fba-path--best' : '') + '">' + (best === 2 ? tag : '') + '<h4>Remove &amp; resell</h4><p class="tc-fba-path-num">' + fmt(ret.resaleNet) + '<span class="tc-fba-perunit">/unit</span></p>' +
        '    <p>Amazon’s removal fee + resale through a partner like Toycycle</p>' +
        '    <label class="tc-fba-slider-label">If resold at <output>' + s.resalePct + '%</output> of your price (your assumption — every brand’s mix differs)' +
        '    <input type="range" min="10" max="90" step="5" value="' + s.resalePct + '" data-resale-slider></label></div>' +
        '</div>' +
        this.renderMathDetails(ret) +
        '<div class="tc-fba-callout"><p class="tc-fba-headline">Returns are costing you ≈ <strong>' + fmtBig(ret.annualCostStatusQuo) + '/year</strong>.' +
        (ret.annualRecoverableDelta > 0 ? ' Toycycle’s returns management could put up to <strong>' + fmtBig(ret.annualRecoverableDelta) + '</strong> of that back in your pocket — at your assumed resale price.' : '') + '</p>' +
        '<div class="tc-fba-cta-row"><a class="tc-fba-cta" data-cta href="#"></a>' +
        '<p class="tc-fba-callout-alt">or email <a href="mailto:partnerships@toycycle.co">partnerships@toycycle.co</a></p></div></div>';
      var ctaEl = this.querySelector('[data-cta]');
      ctaEl.setAttribute('href', ctaUrl);
      ctaEl.textContent = ctaLabel;
      var mathEl = this.querySelector('[data-math]');
      if (mathEl) {
        if (this.mathOpen) mathEl.setAttribute('open', '');
        mathEl.addEventListener('toggle', function () { self.mathOpen = mathEl.open; });
      }
      // 'change' (fires on release), not 'input': recalc re-renders this panel,
      // and replacing the slider mid-drag would break the drag.
      this.querySelector('[data-resale-slider]').addEventListener('change', function (e) {
        s.resalePct = parseFloat(e.target.value); self.recalc();
      });
      this.querySelector('[data-cta]').addEventListener('click', function () {
        if (window.dataLayer) window.dataLayer.push({ event: 'fba_calc_cta_click' });
      });
    }
  }
  if (!customElements.get('tc-fba-calculator')) {
    customElements.define('tc-fba-calculator', TcFbaCalculator);
  }
})();
